export default __webpack_public_path__ + "static/media/calendar.fefadcac.svg";